























































































































































































































































import sjcl from 'sjcl';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapMutations } from 'vuex';
import { ValidationObserver } from 'vee-validate';

import RegisterLayout from '@/components/RegisterLayout.vue';
import FormInput from '@/components/FormInput.vue';
import Select from '@/components/Select.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import Checkbox from '@/components/Checkbox.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import api from '@/libs/api';
// eslint-disable-next-line import/no-cycle
import { showToast } from '@/libs/toast';
import { ToastType } from '../../../store/toast';

@Component({
  components: {
    VuePhoneNumberInput,
    ValidationObserver,
    RegisterLayout,
    FormInput,
    Select,
    Button,
    Loader,
    Checkbox,
  },
  methods: mapMutations(['setUser']),
})
export default class Login extends Vue {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  _ = '';
  tnc = false;
  fullname = '';
  businessname = '';
  brandname = '';
  phonenumber = '';
  email = '';
  password = '';
  confirmpassword = '';
  showResetMessage = false;
  // imageCaptcha = '';
  // captcha = '';
  countDown = 30;
  stopSubmit = 0;
  disable = false;
  results: any = '';
  merchant_mcc: { label: string; value: number } = { label: 'Advertising', value: 7311 };
  categoryCodes: { label: string; value: number }[] = [];
  errors = {
    fullname: '',
    businessname: '',
    brandname: '',
    phonenumber: '',
    email: '',
    password: '',
    confirmpassword: '',
    // captcha: '',
  };

  translations = {
    // countrySelectorLabel: 'Code pays',
    // countrySelectorError: 'Choisir un pays',
    // phoneNumberLabel: 'Numéro de téléphone',
    // example: 'Exemple : 812-345-678',
  }

  loading = false;

  setUser!: (data: unknown) => Promise<void>;

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  }

  mounted() {
    // this.showResetMessage = this.$route.query.from === 'reset';
    // if (this.showResetMessage) {
    //   showToast(ToastType.SUCCESS, 'Congratulations',
    //     'Your password has been changed successfully. Please Login here to access your dashboard');
    // }
    // this.getCaptcha();
    this.getMCC();
    // this.checkConfirmPassword();
  }

  // @Watch('fullname')
  // @Watch('businessname')
  // @Watch('brandname')
  // @Watch('phonenumber')

  onFullNameChange() {
    if (this.fullname.length !== 0 && this.fullname.length < 4) {
      this.errors.fullname = 'Full name must contain more than 3 character';
    } else {
      this.errors.fullname = '';
    }
  }

  onBusinessNameChange() {
    if (this.businessname.length !== 0 && this.businessname.length < 4) {
      this.errors.businessname = 'Business name must contain more than 3 character';
    } else {
      this.errors.businessname = '';
    }
  }

  onBrandNameChange() {
    if (this.brandname.length !== 0 && this.brandname.length < 4) {
      this.errors.brandname = 'Brand name must contain more than 3 character';
    } else {
      this.errors.brandname = '';
    }
  }

  onPhoneNumberChange() {
    // console.log(this.results.formattedNumber);
    if (this.phonenumber !== null) {
      if (this.phonenumber.length <= 1 && this.phonenumber === '0') {
        this.phonenumber = '';
      }
      if (this.phonenumber.length > 15) {
        const maxphone = this.phonenumber.slice(0, 15);
        this.phonenumber = maxphone;
        this.errors.phonenumber = '';
      }
    } else {
      this.phonenumber = '';
    }
  }

  @Watch('email')
  checkEmail() {
    // eslint-disable-next-line no-useless-escape
    this.email = this.email.replaceAll(/[&\/\\#,()$~%'^":*?<>;!{}]/g, '');
  }

  async getMCC() {
    try {
      this.loading = true;
      const { data } = await api.get('/getMCC');
      this.categoryCodes = data.map((e: any) => ({
        label: e.category_name,
        value: e.category_code,
      }));
      console.log(this.categoryCodes);
      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }

  // async getCaptcha() {
  //   try {
  //     const { data } = await api.get('/captcha');
  //     this.imageCaptcha = data.data.user_entity;
  //   } catch (err) {
  //     console.error(err);
  //   }
  // }

  // get captchaImage() {
  //   return `${process.env.VUE_APP_API_URL}/captcha/${this.imageCaptcha}`;
  // }

  @Watch('phonenumber')
  checkPhone() {
    if (this.phonenumber.length <= 1 && this.phonenumber === '0') {
      this.phonenumber = '';
    }
  }

  @Watch('invalid')
  asd() {
    console.log(this.tnc, 'asisssss');
  }

  // @Watch('captcha')
  // checkCaptcha() {
  //   // eslint-disable-next-line no-useless-escape
  //   this.captcha = this.captcha.replaceAll(/[&\/\\#,()$~%'+@^":*?<>;!{}]/g, '');
  // }

  countDownTimer() {
    if (this.countDown > 0) {
      this.disable = true;
      setTimeout(() => {
        this.countDown -= 1;
        this.countDownTimer();
      }, 1000);
    } else {
      this.disable = false;
    }
  }

  async resendEmail() {
    this.loading = true;
    this.countDown = 30;
    this.stopSubmit += 1;
    if (this.stopSubmit < 4) {
      this.countDownTimer();
    }
    if (this.stopSubmit > 2) {
      this.disable = true;
    }
    await api.post('/resend-verify', {
      email: this.email,
    });
    this.loading = false;
  }

  async register() {
    /* eslint-disable @typescript-eslint/camelcase */
    try {
      this.loading = true;
      this.errors = {
        fullname: '',
        businessname: '',
        brandname: '',
        phonenumber: '',
        email: '',
        password: '',
        confirmpassword: '',
        // captcha: '',
      };

      const out = sjcl.hash.sha256.hash(this.password);
      const hash = sjcl.codec.hex.fromBits(out);

      this.onFullNameChange();
      this.onBusinessNameChange();
      this.onBrandNameChange();
      if (this.confirmpassword !== this.password) {
        this.errors.confirmpassword = 'Confirmation paswrod must be same';
        this.loading = false;
        // this.getCaptcha();
        // this.captcha = '';
      } else {
        const { data } = await api.post('/registration', {
          merchant_name: this.businessname,
          merchant_brand: this.brandname,
          merchant_mcc: this.merchant_mcc.value,
          pic_business_name: this.fullname,
          pic_business_email: this.email,
          pic_business_phone: `62${this.phonenumber.replaceAll('+', '')}`,
          password: hash,
          // captcha: this.captcha,
        }, { headers: {} });
        this._ = data;
        // this.sent = true;
        this.$router.push('/confirmationpage');
        (window as any).fbq('track', 'Complete Registration');
        this.countDown = 30;
        this.stopSubmit += 1;
        if (this.stopSubmit < 4) {
          this.countDownTimer();
        }
        if (this.stopSubmit > 2) {
          this.disable = true;
        }
        this.loading = false;
      }
    } catch (err) {
      this.loading = false;
      // this.getCaptcha();
      // this.captcha = '';

      const error = err as any;
      requestAnimationFrame(() => {
        this.$refs.observer.reset();
      });

      const { status } = error.response;

      if (error.response.data.message) {
        showToast(ToastType.FAILED, 'Failed', error.response.data.message);
      }
      if (status === 423) {
        this.$router.push({
          name: 'Locked',
          params: {
            email: this.email,
          },
        });
      } else if (error.response.data.additional_information) {
        error.response.data.additional_information.forEach((item: any) => {
          if (item.field === 'merchant_name') {
            this.errors.businessname = item.error;
          }
          if (item.field === 'merchant_brand') {
            this.errors.brandname = item.error;
          }
          if (item.field === 'pic_business_name') {
            this.errors.fullname = item.error;
          }
          if (item.field === 'pic_business_email') {
            this.errors.email = item.error;
          }
          if (item.field === 'pic_business_phone') {
            this.errors.phonenumber = item.error;
          }
          // if (item.field === 'captcha') {
          //   this.errors.captcha = item.error;
          // }
          if (item.field === 'password') {
            this.errors.password = item.error;
          }
        });
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  created() {
    (window as any).fbq('track', 'Load Page Registration');
  }

  get sent() {
    return this.$route.meta?.isSent || false;
  }
}
